export default "__VITE_ASSET__9j_C5$dx__"